import Header from './Header';
import Footer from './Footer';

export default function Shell({ children }) {
  return (
    <div className="min-h-screen bg-[var(--mm-cream)] flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
